import { render, staticRenderFns } from "./Assur_hospi.vue?vue&type=template&id=1d6394ee&scoped=true"
import script from "./Assur_hospi.vue?vue&type=script&lang=js"
export * from "./Assur_hospi.vue?vue&type=script&lang=js"
import style0 from "./Assur_hospi.vue?vue&type=style&index=0&id=1d6394ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6394ee",
  null
  
)

export default component.exports